import * as React from 'react';

import './BarrGraphic.scss';
import { Paper, Typography, LinearProgress } from '@material-ui/core';
import { BarChart, Bar, XAxis, YAxis
    // , Tooltip
    , ResponsiveContainer, LabelList, CartesianGrid } from 'recharts';
import { BarrGraphicModal } from './BarrGraphicModal';

// tslint:disable-next-line:no-empty-interface
export interface IBarrGraphicProps {
    dataProp: any,
    dimensionIndex: number,
    loading: boolean,
    metricsIndex: number,
    title: string,
}

// tslint:disable-next-line:no-empty-interface
export interface IBarrGraphicState {
    dialogOpen: boolean,
}

export interface IBarrGraphicDataChart {
    dimension: string;
    metric: number;
}

// statless component
export const BarrGraphicDataChart = ({ data, dataPropsParam, dimensionIndexProps, metricsIndexProps, titleProps }: { 
    data: IBarrGraphicDataChart[], dataPropsParam: any[], dimensionIndexProps: number,
    metricsIndexProps: number, titleProps:string }) => (

    <div>
        <ResponsiveContainer width="100%" height={300} >
            <BarChart
                    data={data}
                    margin={{ top: 5, right: 20, left: 100, bottom: 5 }}
                    layout="vertical">
                    <CartesianGrid vertical={false} horizontal={false} />
                    <XAxis type="number" hide={true}/>
                    <YAxis yAxisId="center" type="category" dataKey="dimension"  tick={{fontSize: '65%'}}/>
                    <Bar yAxisId="center" dataKey="metric" fill="#46a3d0" barSize={25} isAnimationActive={false} >
                        <LabelList dataKey="metric" position="right" className="recharts-label-custom-black" />
                    </Bar>
                </BarChart>
        </ResponsiveContainer>
        <BarrGraphicModal dataProp={dataPropsParam} dimensionIndex={dimensionIndexProps} 
            metricsIndex={metricsIndexProps} title={titleProps} loading={false} />
    </div>
);

const dataFilled = (data: any) => {
    return data && data.rows && !!data.rows.length
}

export class BarrGraphic extends React.Component<IBarrGraphicProps, IBarrGraphicState> {
    constructor(props: IBarrGraphicProps) {
        super(props);
        this.state = {
          dialogOpen: false,
        }
    }

    public render() {
        const data = this.props.dataProp;

        return (
            <Paper style={{position: "relative", height: "100%"}} className="publisher-sale-block panel-block" >
                <Typography variant="headline" className="panel-title" component="title">
                    {this.props.title}
                </Typography>
                {
                    this.props.loading ? 
                        <LinearProgress /> :
                        dataFilled(data) ?
                            (<BarrGraphicDataChart data={this.BarrGraphicDataChartMap(data.rows)} dataPropsParam={this.props.dataProp} dimensionIndexProps={this.props.dimensionIndex} 
                                metricsIndexProps={this.props.metricsIndex} titleProps={this.props.title} />) :
                            (
                                <Typography variant="body2" className="comparative" component="p">
                                    Não há informações de vendas
                                </Typography>
                            )
                }
            </Paper>
        );
    }

    private BarrGraphicDataChartMap = (data: any[]) => {

        if(data.length > 5) {
            data = data.slice(0,5);
        }
        const mappedData: IBarrGraphicDataChart[] = [];

        data.forEach(e => {

            const item: IBarrGraphicDataChart = {
                dimension: e.dimensions[this.props.dimensionIndex],
                metric: Number(e.metrics[0].values[this.props.metricsIndex]),
            };

            mappedData.push(item);

        });

        return mappedData;
    }
}



// WEBPACK FOOTER //
// ./src/component/administration/analytics/shared/graphics/barrGraphic/BarrGraphic.tsx